// footer — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: block;
    background: var(--run-wf-surface);
    color: var(--run-wf-text);
    font-size: var(--run-footer-font-size, var(--run-font-size-sm));
    font-family: var(--run-wf-font-family, var(--run-font-semantic-family-body));
    font-weight: 400;
  }

  .inner {
    max-width: var(--run-footer-max-width, 87.5rem);
    margin-inline: auto;
    padding-inline: var(--run-footer-gutter, var(--run-space-semantic-xs));
    padding-block-start: var(--run-footer-top-padding, var(--run-space-semantic-sm));
    padding-block-end: var(--run-footer-gutter, var(--run-space-semantic-xs));
  }

  .columns {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--run-footer-columns-gap, var(--run-space-semantic-sm));
  }

  @media (min-width: 40em) {
    .columns {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 64em) {
    .columns {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  run-divider {
    --run-divider-color: var(--run-wf-border);
    display: block;
    margin-block: var(--run-footer-gutter, var(--run-space-semantic-xs));
    border-style: dashed;
  }

  .bottom-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: var(--run-footer-gap, var(--run-space-semantic-xs));
    flex-wrap: wrap;
    color: var(--run-wf-text-subtle);
  }

  ::slotted(a),
  .bottom-bar ::slotted(a) {
    color: var(--run-wf-text-link);
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `
    <div class="inner">
      <div class="columns">
        <slot name="columns"></slot>
      </div>
      <run-divider aria-hidden="true"></run-divider>
      <div class="bottom-bar">
        <slot name="bottom-bar"></slot>
      </div>
    </div>
  `;
}